import { trackEvent } from '../../analytics/analyticsTracker';

export function trackFetchLatency(durationMs: number, status: number, url: string, payloadSize: string): void {
  trackEvent({
    eventName: 'survey_fetch_latency',
    metadata: {
      durationMs,
      status,
      success: true,
      url,
      payloadSize,
    },
  });
}

export function trackFetchError(status: number | string, url: string, errorMessage: string): void {
  trackEvent({
    eventName: 'api_error',
    metadata: {
      apiName: 'GET Survey Layout',
      status,
      url,
      errorMessage,
    },
  });
}
